import { Location, matchPath } from 'react-router-dom';
import { userNavigationBarAllowedRoutes } from './Routes';

export const checkUserNavigationBarEnabled = (location: Location): boolean => {
  return userNavigationBarAllowedRoutes.some((pattern) => {
    if (matchPath(pattern, location.pathname)) {
      return true;
    }
    return false;
  });
};

export default checkUserNavigationBarEnabled;
